import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.div`
  ${({ displayState, theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${displayState?.size ? `${displayState?.size}px` : '30px'};
    height: ${displayState?.size ? `${displayState?.size}px` : '30px'};
    border-radius: 50%;
    background: ${displayState?.primary ? (theme?.colour?.primary ?? '#1DBD6B') : (theme?.colour?.secondary ?? '#04333B')};
    font-size: ${displayState?.size ? `${displayState?.size * 0.4}px` : '12px'};
    flex-shrink: 0;
    color: white;
  `}
`;


export default Atom({ type: 'label', dataType: 'string', template })